import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { api } from '../lib/api'
import { fmtDate, money, type AdminDeal, type PageMeta } from '../lib/types'
import { StatusBadge } from '../components/StatusBadge'

export function DealsPage() {
  const [params, setParams] = useSearchParams()
  const status = params.get('status') || ''
  const page = Number(params.get('page') || 1)
  const qs = new URLSearchParams({ page: String(page) })
  if (status) qs.set('status', status)

  const { data, isLoading } = useQuery({
    queryKey: ['deals', qs.toString()],
    queryFn: () => api<{ items: AdminDeal[]; meta: PageMeta }>(`/admin/deals?${qs}`),
  })

  return (
    <div>
      <h1 className="page-title">Выбор исполнителя</h1>
      <p className="page-sub">Статусы и суммы сделок</p>
      <div className="toolbar">
        <select className="select" value={status} onChange={(e) => {
          const next = new URLSearchParams(params)
          if (e.target.value) next.set('status', e.target.value); else next.delete('status')
          next.delete('page')
          setParams(next)
        }}>
          <option value="">Все статусы</option>
          {['in_progress','completed','cancelled'].map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Номер</th>
              <th>Проект</th>
              <th>Заказчик</th>
              <th>Исполнитель</th>
              <th>Цена из отклика</th>
              <th>Статус</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={7}>Загрузка…</td></tr>}
            {data?.items.map((d) => (
              <tr key={d.id}>
                <td>{d.public_number}</td>
                <td style={{ maxWidth: 220, whiteSpace: 'normal' }}>{d.order_title || '—'}</td>
                <td>{d.customer_name || '—'}</td>
                <td>{d.executor_name || '—'}</td>
                <td>{money(d.amount, d.currency)}</td>
                <td><StatusBadge value={d.status} /></td>
                <td>{fmtDate(d.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
